import { render, staticRenderFns } from "./SettingsPreferences.vue?vue&type=template&id=a8d71aa8&scoped=true&"
import script from "./SettingsPreferences.vue?vue&type=script&lang=js&"
export * from "./SettingsPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d71aa8",
  null
  
)

export default component.exports